import { Route, Routes } from "react-router-dom";
import React, { Suspense } from "react";
const ActivateAccount = React.lazy(() =>
  import("./components/Auth/Activate/ActivateAccount")
);
const ActivateNewPassword = React.lazy(() =>
  import("./components/Auth/Activate/ActivateNewPassword")
);
const AdminRoute = React.lazy(() =>
  import("./components/Auth/AdminRoute/AdminRoute")
);
const AdminOrManagerRoute = React.lazy(() =>
  import("./components/Auth/AdminOrManagerRoute/AdminOrManagerRoute")
);
const Contacts = React.lazy(() => import("./components/Contacts/Contacts"));
const DevPage = React.lazy(() => import("./pages/DevPage"));
const DevRoute = React.lazy(() =>
  import("./components/Auth/DevRoute/DevRoute")
);
const EndatoPage = React.lazy(() => import("./pages/EndatoPage"));
const ImportExportPage = React.lazy(() => import("./pages/ImportExportPage"));
const Layout = React.lazy(() => import("./components/Layout/Layout"));

const Login = React.lazy(() => import("./components/Auth/Login/Login"));
const MarketingPage = React.lazy(() => import("./pages/MarketingPage"));
const MassDeletePage = React.lazy(() => import("./pages/MassDeletePage"));
const TrashBinPage = React.lazy(() => import("./pages/trash-bin/TrashBinPage"));
const MassEmailsPage = React.lazy(() =>
  import("./pages/mass-emails/MassEmailsPage")
);
const NotFoundPage = React.lazy(() =>
  import("./components/NotFoundPage/NotFoundPage")
);
const Properties = React.lazy(() =>
  import("./components/Properties/Properties")
);
const RecoverPassword = React.lazy(() =>
  import("./components/Auth/RecoverPassword/RecoverPassword")
);
const ReportsPage = React.lazy(() => import("./pages/ReportsPage"));
const Requirements = React.lazy(() =>
  import("./components/Requirements/Requirements")
);
const RequireAuth = React.lazy(() =>
  import("./components/Auth/RequireAuth/RequireAuth")
);
const ServerErrorPage = React.lazy(() =>
  import("./components/ServerErrorPage/ServerErrorPage")
);
const Settings = React.lazy(() => import("./components/Settings/Settings"));
const StrictDevRoute = React.lazy(() =>
  import("./components/Auth/StrictDevRoute/StrictDevRoute")
);

import Loader from "./components/UI/Loader/Loader";

function App() {
  return (
    <Suspense fallback={<Loader global />}>
      <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/activate/:token" element={<ActivateAccount />} />
          <Route
            path="/reset-password/:token"
            element={<ActivateNewPassword />}
          />
          <Route path="/recover" element={<RecoverPassword />} />
          <Route path="/" element={<Layout />}>
            <Route
              path="/contacts/*"
              element={
                <RequireAuth>
                  <Contacts />
                </RequireAuth>
              }
            />
            <Route
              path="/properties/*"
              element={
                <RequireAuth>
                  <Properties />
                </RequireAuth>
              }
            />
            <Route
              path="/requirements/*"
              element={
                <RequireAuth>
                  <Requirements />
                </RequireAuth>
              }
            />
            <Route
              path="/settings"
              element={
                <AdminOrManagerRoute>
                  <Settings />
                </AdminOrManagerRoute>
              }
            />
            <Route
              path="/marketing"
              element={
                <DevRoute>
                  <MarketingPage />
                </DevRoute>
              }
            />
            <Route
              path="/endato"
              element={
                <DevRoute>
                  <EndatoPage />
                </DevRoute>
              }
            />
            <Route
              path="/import-export"
              element={
                <AdminRoute>
                  <ImportExportPage />
                </AdminRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <AdminOrManagerRoute>
                  <ReportsPage />
                </AdminOrManagerRoute>
              }
            />
            <Route
              path="/mass-emails"
              element={
                <AdminRoute>
                  <MassEmailsPage />
                </AdminRoute>
              }
            />
            <Route
              path="/mass-delete"
              element={
                <AdminOrManagerRoute>
                  <MassDeletePage />
                </AdminOrManagerRoute>
              }
            />
            <Route
              path="/trash-bin"
              element={
                <AdminOrManagerRoute>
                  <TrashBinPage />
                </AdminOrManagerRoute>
              }
            />
            <Route
              path="/dev"
              element={
                <StrictDevRoute>
                  <DevPage />
                </StrictDevRoute>
              }
            />

            <Route path="/500" element={<ServerErrorPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Suspense>
  );
}

export default App;
